<template>
  <div :class="['monitor',{'active':show}]">
    <div class="grid-content bg-purple grid-left-ico box animated">
      <img src="../static/1.png" height="48" width="48" class="gt">
      <a class="grid-content-a1">{{msg}}</a>
      <a :href="url" class="grid-content-a2" @click="show = !show">立即下载</a>
      <a class="close" @click="show = !show"><img src="../static/2.png" height="40" width="40"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ep-brower',
  data() {
    return {
      show: false
    }
  },
  props: {
    msg: {
      type: String,
      default () {
        return '您正在使用的IE、360、搜狗极其不稳定，会导致页面崩溃、功能无法正常使用。请更换谷歌Chrome浏览器登录系统。'
      }
    },
    url: {
      type: String,
      default () {
        return 'http://www.baidu.com/link?url=03u7l0NIhkUmGHeZH1qSZVu5O1uDoIBXZqO-rLnQFfkeCQYfML2CTeD8xWkhFB8qJubYXT21C22Beh4l4nkufxKBgvcmKnpL9rGfapaOWcm'
      }
    }
  },
  mounted() {
    this.isCh()
  },
  methods: {
    isCh() {
      var userAgent = navigator.userAgent;
      var ischrom = userAgent.indexOf("Chrome") > -1;
      if (ischrom) {
        this.show = false
        var explorer = window.navigator.userAgent.toLowerCase();
        var ver = explorer.match(/chrome\/([\d.]+)/)[1];
        if (ver.substring(0, ver.indexOf(".")) > 50) {
          this.show = false
        } else {
          this.show = true
        }
      } else {
        this.show = true
        return
      }
    }
  },
}

</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}

.monitor {
  position: fixed;
  top: -50px;
  opacity: 0;
  height: 65px;
  box-sizing: border-box;
  width: 735px;
  z-index: 888;
  font-size: 0;
  font-family: "微软雅黑";
  left: calc((100% - 900px) / 2);
  -webkit-transition: all .5s ease-in-out;
  -moz-transition: all .5s ease-in-out;
  transition: all .5s ease-in-out;
  box-sizing: border-box
}

.active {
  top: 30px;
  opacity: 1;
}

.grid-content {
  width: 720px;
  height: 65px;
  box-sizing: border-box;
  border: 0;
  overflow: hidden;
  line-height: 20px;
  min-height: 40px;
  box-shadow: 0 0px 3px #CACACA;
  padding: 0 10px;
  padding-left: 0;
}

.grid-content img {
  position: absolute;
  vertical-align: middle;
  top: 0;
  left: 0;
}

.bg-purple {
  background: #eb3643!important;
  position: relative;
}

.grid-content-a1 {
  margin: 6px 0 0 70px;
  display: inline-block;
  line-height: 25px;
  width: 600px;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  letter-spacing: 1px;
  font-family: '微软雅黑';

}

.grid-content-a2 {
  margin-left: -90px;
  border-bottom: solid 1px #fff;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
    font-weight: bold;
}

.grid-content-a3 {
  color: #999999;
  margin-left: 20px;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.box {
  animation: fadeIn 0.5s ease-in-out;
}

.close {
  display: inline-block;
  position: relative;
  right: -25px;
  top: -35px;
  font-size: 14px;
  cursor: pointer;
  color: #fff;
}

.gt {
  font-size: 65px;
  color: #fff;
  margin: 8px 0 0 10px;
}

</style>



// WEBPACK FOOTER //
// BrowserCheck.vue?7b254528